import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Hieronder vindt u alle documentatie met betrekking tot uw bouwnummer.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0"} }, [
  /*#__PURE__*/_createTextVNode("Er zijn (nog) geen documenten beschikbaar."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Binnenkort vindt u hieronder vindt u alle documentatie met betrekking tot uw bouwnummer.")
], -1)

import { useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { documentStore } from '@/stores/document'
import DocumentList from '@/components/document/DocumentList.vue'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'Documents',
  setup(__props) {

const router = useRouter()

onMounted(() => {
  documentStore().getDocuments()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18, offset: 3}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Documenten",
            loading: _unref(documentStore)().loading
          }, {
            extra: _withCtx(() => [
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (!Array.isArray(_unref(documentStore)().documents))
                ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_row, {
                    key: 1,
                    style: {"margin-bottom":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })),
              (!Array.isArray(_unref(documentStore)().documents))
                ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_unref(generalStore)().desktop)
                            ? (_openBlock(), _createBlock(_component_a_tabs, {
                                key: 0,
                                "tab-position": "left",
                                activeKey: _unref(documentStore)().activeTab,
                                "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_unref(documentStore)().activeTab) = $event))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documentStore)().documents, (dir) => {
                                    return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                      key: dir.name,
                                      tab: `${dir.name} (${dir.documents.length})`
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(DocumentList, {
                                          "media-items": dir.documents
                                        }, null, 8, ["media-items"])
                                      ]),
                                      _: 2
                                    }, 1032, ["tab"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["activeKey"]))
                            : (_openBlock(), _createBlock(_component_a_collapse, {
                                key: 1,
                                activeKey: _unref(documentStore)().activeTab,
                                "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_unref(documentStore)().activeTab) = $event))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documentStore)().documents, (dir) => {
                                    return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                      key: dir.name,
                                      header: `${dir.name} (${dir.documents.length})`
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(DocumentList, {
                                          "media-items": dir.documents
                                        }, null, 8, ["media-items"])
                                      ]),
                                      _: 2
                                    }, 1032, ["header"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["activeKey"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})